import mixpanel from 'mixpanel-browser';
import React, { useEffect } from 'react';
import DILogo from 'src/components/DILogo';
import MicrosoftSignInButton from 'src/components/MicrosoftSignInButton';
import FEATURES from 'src/featureMap';
import { useAppToolchain } from 'src/hooks/useAppToolchain';
import withAnalytics from 'src/lib/withAnalytics';
import cudaLogo from 'src/static/barracuda-logo-light.svg';
import {
	BDSProvider,
	Box,
	Paper,
	Typography,
} from '@barracuda-internal/bds-core-v2';

export function LoginSidebar(): React.ReactElement {
	const { oidcUserManager } = useAppToolchain();

	useEffect(() => mixpanel.identify(), []);

	const signinRedirect = (provider) => {
		return oidcUserManager.signinRedirect({
			acr_values: ['idp:' + provider],
		});
	};

	return (
		<BDSProvider>
			<aside>
				<Paper
					sx={{
						position: 'relative',
						height: '100vh',
						maxWidth: '560px',
						backgroundColor: '#162618',
						color: 'white',
						display: 'flex',
						flexDirection: 'column',
						padding: '36px',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flex: '0 0 128px',
							justifyContent: 'center',
						}}
					>
						<DILogo size="100%" />
					</Box>

					<Box
						sx={{
							color: 'white',
							display: 'flex',
							flex: 1,
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Typography variant="h1" gutterBottom color="white">
							Find sensitive and malicious data in your Office 365
							OneDrive and SharePoint
						</Typography>
						<Typography variant="body1" gutterBottom color="white">
							Barracuda Data Inspector scans files in OneDrive and
							SharePoint and reports on sensitive information or
							malicious data.
						</Typography>
						<Box sx={{ marginTop: '32px', marginBottom: '32px' }}>
							<MicrosoftSignInButton
								onClick={withAnalytics(
									FEATURES.loginButtonClick,
									() => signinRedirect('microsoft'),
								)}
							/>
						</Box>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<Box
							component="img"
							src={cudaLogo}
							alt="Barracuda"
							sx={{ width: '160px' }}
						/>
					</Box>
				</Paper>
			</aside>
		</BDSProvider>
	);
}
